exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription-summary__header {\n  text-align: center;\n}\n.subscription-summary__header.header--dates {\n  margin-bottom: 35px;\n}\n.subscription-summary__address {\n  white-space: pre-line;\n}\n.address__header {\n  display: block;\n  font-weight: bold;\n}\n.subscription-summary__footer {\n  border-top: 1px solid #f4f4f4;\n}", ""]);

// exports
